import { IUserRegisterService } from "modules/cpfRegister/service/UserRegisterService";
import { differenceInYears } from "date-fns";

export const UserValidateUseCase = async (
  service: IUserRegisterService,
  localId: string,
  cpf: string
) => {
  const user = await service.getUserData(localId, cpf);
  const age = differenceInYears(new Date(), new Date(user.DataNascimento));
  return age >= 18;
};
